import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';

const { Types, Creators } = createActions(
  {
    success: ['data'],
    reset: [],
  },
  { prefix: 'PERMISSION_FILTER_' }
);

export interface PermissionFilterState {
  data: any | null;
}

interface SuccessPermissionFilter {
  data: any;
}

const INITIAL_STATE: PermissionFilterState = {
  data: { page: 1, limit: 10 },
};

const success = (state: PermissionFilterState, action: SuccessPermissionFilter) =>
  update(state, {
    data: { $set: action.data },
  });

const reset = () => INITIAL_STATE;

export const permissionFilter = createReducer(INITIAL_STATE, {
  [Types.SUCCESS]: success,
  [Types.RESET]: reset,
});

export const PermissionFilterTypes = Types;
export const PermissionFilterActions = Creators;